import { Component, OnInit } from '@angular/core';
import { SidebarItem } from 'src/app/models/Sidebar.interface';
import { CommonService } from 'src/app/services/common.service';
import { GoogleAnalyticsEventsService } from 'src/app/services/google-analytics-events.service';
import { SidebarService } from 'src/app/services/sidebar.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {
  isTooltipDisabled = true;
  isSidebarHidden: boolean;
  orgID = '';
  sidebarItems: SidebarItem[] = [
    {
      title: 'SIDE_NAVBAR_MENU_TITLE.DASHBOARD',
      inactiveLink: './assets/icons/home_inactive.svg',
      activeLink: './assets/icons/home_active.svg',
      routerLink: '/dashboard',
      tooltipMessage: 'SIDE_NAVBAR_MENU_TITLE.DASHBOARD',
      showDropdown: false,
      dropDownItems: [],
      ga_events : { category: 'reseller-portal', action: 'Go to dashboard', label: 'from side menu', value: ''}
    },
    {
      title: 'SIDE_NAVBAR_MENU_TITLE.CUSTOMERS',
      inactiveLink: './assets/icons/customers-nav.svg',
      activeLink: './assets/icons/customers-nav-active.svg',
      routerLink: '/customers',
      tooltipMessage: 'SIDE_NAVBAR_MENU_TITLE.CUSTOMERS',
      showDropdown: false,
      dropDownItems: [
        // un-commnet to add the dropdown items to the sidebar menu
        // { title: 'Menu Item 1', routerLink: ''},
        // { title: 'Menu Item 2', routerLink: ''}
      ],
      ga_events : { category: 'reseller-portal', action: 'Go to customer list', label: 'from side menu', value: ''}
    },
    {
      title: 'SIDE_NAVBAR_MENU_TITLE.CASES',
      inactiveLink: './assets/icons/case_inactive.svg',
      activeLink: './assets/icons/case_active.svg',
      routerLink: '/cases',
      tooltipMessage: 'SIDE_NAVBAR_MENU_TITLE.CASES',
      showDropdown: false,
      dropDownItems: [],
      ga_events : { category: 'reseller-portal', action: 'Go to case list', label: 'from side menu', value: ''}
    },
    {
      title: 'SIDE_NAVBAR_MENU_TITLE.CALENDAR',
      inactiveLink: './assets/icons/calendar_inactive.svg',
      activeLink: './assets/icons/calendar_active.svg',
      routerLink: '/calendar',
      tooltipMessage: 'SIDE_NAVBAR_MENU_TITLE.CALENDAR',
      showDropdown: false,
      dropDownItems: [],
      ga_events : { category: 'reseller-portal', action: 'Go to Calendar', label: 'from side menu', value: ''}
    },
    {
      title: 'SIDE_NAVBAR_MENU_TITLE.SUBSTRATES',
      inactiveLink: './assets/icons/substrate_inactive.svg',
      activeLink: './assets/icons/substrate_active.svg',
      routerLink: '/substrates',
      tooltipMessage: 'SIDE_NAVBAR_MENU_TITLE.SUBSTRATES',
      showDropdown: false,
      dropDownItems: [],
      ga_events : { category: 'reseller-portal', action: 'Go to subrate list', label: 'from side menu', value: ''}
    },
    {
      title: 'PLANS',
      inactiveLink: './assets/icons/icon-serviceplan-black.svg',
      activeLink: './assets/icons/icon-serviceplan-blue.svg',
      routerLink: '/plans',
      tooltipMessage: 'PLANS',
      showDropdown: false,
      dropDownItems: [],
      ga_events : { category: 'reseller-portal', action: 'Menu Element - Clicked', label: 'Menu - Service Plans', value: ''}
    },
    {
      title: 'SIDE_NAVBAR_MENU_TITLE.CONFIGURATION',
      inactiveLink: './assets/icons/coverage_inactive.svg',
      activeLink: './assets/icons/coverage_active.svg',
      routerLink: '/coverage_area',
      tooltipMessage: 'SIDE_NAVBAR_MENU_TITLE.CONFIGURATION',
      showDropdown: false,
      dropDownItems: [],
      ga_events : { category: 'reseller-portal', action: 'Go to filter customer', label: 'from side menu', value: ''}
    }
  ];

  constructor(
    private sidebarService: SidebarService,
    private googleAnalyticsEventsService: GoogleAnalyticsEventsService,
    private commonService: CommonService,
    private auth: AuthService
  ) { }

  ngOnInit(): void {
    // subscribe to show/hide the sidebar in small screens
    this.sidebarService.isSidebarHidden.subscribe((value: boolean) => {
      this.isSidebarHidden = value;
    });
    this.auth.isUserRole$.subscribe((response) => {
      if (response) {
        this.sidebarItems = this.sidebarItems.filter((item: SidebarItem) =>
          [
            'SIDE_NAVBAR_MENU_TITLE.DASHBOARD',
            'PLANS',
            'SIDE_NAVBAR_MENU_TITLE.CONFIGURATION',
          ].includes(item.title)
        );
      }
    });
  }

  changeTooltipVisiblity($event): void {
    this.isTooltipDisabled = $event;
  }

  toggleDropdown(item: SidebarItem): void {
    item.showDropdown = !item.showDropdown;
  }

  hideDropdowns($event): void {
    this.sidebarItems.forEach((item: SidebarItem) => {
      item.showDropdown = false;
    });
  }

  hideSidebar(sidebarItem): void {
    if(sidebarItem != null) {
      let event = sidebarItem.ga_events;
      if(sidebarItem.routerLink == "/plans") {
        this.orgID =  this.commonService.organizationID;
        let label = `${this.orgID}`
        event.label = label
      }
      this.googleAnalyticsEventsService.emitEvent(event.category, event.action, event.label, event.value)
    }
    this.sidebarService.changeSidebarVisiblity(true);
  }
}
